/**
 * @generated SignedSource<<9936c66f475f5b5cae80af06b548f8cb>>
 * @relayHash 1246767ea7fb9149278e67c3ec09752c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5

import type { ConcreteRequest } from 'relay-runtime';
export type loomUserPermissionQuery$variables = {
  loomResourceId: string;
  principalId: string;
};
export type loomUserPermissionQuery$data = {
  readonly bulkPermitted: ReadonlyArray<{
    readonly permissionId: string | null;
    readonly permitted: boolean | null;
    readonly principalId: string | null;
    readonly resourceId: string | null;
  } | null> | null;
};
export type loomUserPermissionQuery = {
  response: loomUserPermissionQuery$data;
  variables: loomUserPermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loomResourceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "principalId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "permissionIds",
        "value": [
          "write"
        ]
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "principalIds.0",
            "variableName": "principalId"
          }
        ],
        "kind": "ListValue",
        "name": "principalIds"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "resourceIds.0",
            "variableName": "loomResourceId"
          }
        ],
        "kind": "ListValue",
        "name": "resourceIds"
      }
    ],
    "concreteType": "BulkPermittedResponse",
    "kind": "LinkedField",
    "name": "bulkPermitted",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "principalId"
      },
      {
        "kind": "ScalarField",
        "name": "resourceId"
      },
      {
        "kind": "ScalarField",
        "name": "permissionId"
      },
      {
        "kind": "ScalarField",
        "name": "permitted"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "loomUserPermissionQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "loomUserPermissionQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1246767ea7fb9149278e67c3ec09752c",
    "id": "b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5",
    "metadata": {},
    "name": "loomUserPermissionQuery",
    "operationKind": "query",
    "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
  }
};
})();

(node as any).hash = "714c5537c580f754bda23bcf99534b30";

export default node;
